import React from "react";
import { Tooltip } from "antd";
import { ColumnsType } from "antd/lib/table";
import { Pencil } from "assets/icons";
import dayjs from "dayjs";
import { IColumn } from "typings/global";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./index.styled";

const ColumnsTable = ({ handleClick }) => {
  const TAG_NUMBER = useTranslation({ id: "tag_number" });
  const REGISTRATION_DATE = useTranslation({ id: "registration_date" });
  const INACTIVATION_DATE = useTranslation({ id: "inactivation_date" });
  const CHANGE_BY = useTranslation({ id: "changed_by" });
  const UNIT = useTranslation({ id: "unit" });
  const ACTION = useTranslation({ id: "action" });
  const PLATE = useTranslation({ id: "plate" });
  const TAG_EDITING = useTranslation({ id: "tag_editing" });

  const collums: Array<IColumn> = [
    {
      title: TAG_NUMBER,
      dataIndex: "tagNumber",
      filterMultiple: false,
      render: (tagNumber: ColumnsType<any>) => `${tagNumber}`,
      width: "20%",
      key: "tagNumber",
    },
    {
      title: PLATE,
      dataIndex: "vehiclePlate",
      filterMultiple: false,
      render: (vehiclePlate: ColumnsType<any>) => `${vehiclePlate || "--"}`,
      width: "10%",
      key: "vehiclePlate",
    },
    {
      title: UNIT,
      dataIndex: "locationDescription",
      filterMultiple: false,
      render: (locationDescription: ColumnsType<any>) => `${locationDescription}`,
      width: "15%",
      key: "locationDescription",
    },
    {
      title: REGISTRATION_DATE,
      dataIndex: "createdAt",
      render: (createdAt: string) => (createdAt ? `${dayjs.utc(createdAt).local().format("DD/MM/YYYY HH:mm")}` : "--"),
      width: "15%",
      key: "createdAt",
    },
    {
      title: INACTIVATION_DATE,
      dataIndex: "inactivatedAt",
      filterMultiple: false,
      render: (inactivatedAt: string) => (inactivatedAt ? `${dayjs.utc(inactivatedAt).local().format("DD/MM/YYYY HH:mm")}` : "--"),
      width: "15%",
      key: "inactivatedAt",
    },
    {
      title: CHANGE_BY,
      dataIndex: "userName",
      filterMultiple: false,
      render: (userName: ColumnsType<any>) => `${userName}`,
      width: "20%",
      key: "userName",
    },
    {
      title: ACTION,
      dataIndex: "disabledEdit",
      width: "5%",
      key: "disabledEdit",
      render: (disabledEdit, record) =>
        !disabledEdit ? (
          <S.ActionContainer>
            <button onClick={() => handleClick(record)}>
              <Tooltip placement="top" title={TAG_EDITING}>
                <Pencil className="pencilEdit" data-testid="editItemTable" />
              </Tooltip>
            </button>
          </S.ActionContainer>
        ) : (
          <S.ActionContainer>
            <button>
              <Pencil className="pencilDisabledEdit" data-testid="disabledEditItemTable" />
            </button>
          </S.ActionContainer>
        ),
    },
  ];
  return collums;
};

export default ColumnsTable;
